export const toFloat = text => {
  if (!text) return;

  if (isInt(text) || isFloat(text)) {
    return text;
  } else {
    return parseFloat(text.toString().replace(/\./g, "").replace(/\,/g, "."));
  }
};

const isInt = n => {
  return Number(n) === n && n % 1 === 0;
};

const isFloat = n => {
  return Number(n) === n && n % 1 !== 0;
};

export const maskRealBeautify = value => {
  return toFloat(value ?? "")
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
};

export const maskCpfCnpj = target => {
  let targetF = clearMask(target);

  if (parseInt(target) || isInt(targetF) || isFloat(targetF)) {
    if (targetF.length <= 11) {
      return maskCpf(targetF);
    } else {
      return maskCnpj(targetF.toString().substr(0, 14));
    }
  } else {
    return target;
  }
};

function clearMask(target) {
  return target.replace(/\D/g, "");
}
function maskCpf(value) {
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
}
function maskCnpj(value) {
  return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
}
